import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { IconModule } from 'src/components/icon/icon.module';
import { ToastSeverityType } from 'src/definitions/toast.definition';
import { ToastService } from 'src/services/toast.service';
import { GlobalService } from 'src/services/global.service';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  standalone: true,
  imports: [CommonModule, IconModule, ToastModule],
  providers: [MessageService],
})
export class _ToastComponent implements OnInit {
  protected toastPosition: 'top-center' | 'top-right' = 'top-right';

  protected ToastSeverityType = ToastSeverityType;

  constructor(
    private toastService: ToastService,
private globalService: GlobalService,
    protected messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.toastService.toast$.subscribe((toast) => {
      if (!toast) return;
      this.messageService.clear();

      this.toastPosition = 'top-right';
      this.messageService.add({ ...toast, life: 2000 });
    });
  }
}
